export const lowerCaseValues = <T extends object>(obj: T): T => {
  return Object.entries(obj)
    .map(([key, value]) => [key, typeof value === 'string' ? value.toLowerCase() : value])
    .reduce((sum, [key, value]) => Object.assign(sum, { [key]: value }), {} as T)
}

export interface Dictionary<T> {
  [key: string]: T
}

export const isEmpty = (obj: object): boolean => Object.keys(obj).length === 0
